import { Badge } from '@/components/ui/badge';
import { MerchantOrderStatusEnum } from '@/graphql/generatedTypes';
import { getStatusTranslation } from '../../utils/orderListFilters';

export function OrderStatusBadge({
  status,
}: {
  status: MerchantOrderStatusEnum;
}) {
  const isError =
    status === MerchantOrderStatusEnum.Error ||
    status === MerchantOrderStatusEnum.Invalid;
  return (
    <Badge variant={isError ? 'destructive' : 'secondary'}>
      {getStatusTranslation(status)}
    </Badge>
  );
}
